import { useCollection } from '@/composables/useDataTableProps';
import { ApplicationType, ApplicationTypeCollection } from '@/models/ApplicationType';

const collection = new ApplicationTypeCollection();
const reactiveData = useCollection<ApplicationTypeCollection, ApplicationType>(collection, { pageSize: -1 });
let loadingPromise: Promise<ApplicationTypeCollection> | null = null;

export function usePGApplicationTypes() {
    if (reactiveData.collection.length() === 0) {
        reactiveData.collection.setQueryParams({ filter: [{ id: 'type', property: 'type', value: 'pg' }] });
        loadingPromise = reactiveData.collection.query();
    }
    return {
        collection: reactiveData.collection,
        loading: loadingPromise
    };
}
